import React from "react";

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFaceSmile,
  faPencil
} from "@fortawesome/free-solid-svg-icons";

const RRLegajo = ({l,index,handleEditLegajo}) =>{

    return <div className="rrLegajoDiv">
            <FontAwesomeIcon icon={faFaceSmile} className="rrIcon"/>
            <div className="infoDiv">
                <h6>Codigo:</h6>
                <label>{l.codigo}</label>
            </div>
            <div className="infoDiv">
                <h6>Nombre:</h6>
                <label>{l.nombre}</label>
            </div>
            <div className="infoDiv">
                <h6>Categoría:</h6>
                <label>{`${l.catego} - ${l.categoriaNombre}`}</label>
            </div>
            <div className="utilitesDiv" onClick={()=>handleEditLegajo(l)}>
                <FontAwesomeIcon className="utilityIcon" icon={faPencil}/>
            </div>
    </div>

}

export default RRLegajo;